import {
  useContext,
  useEffect,
  useRef,
  useState,
  type ComponentProps
} from 'react'
import { UNSAFE_DataRouterContext, useLocation } from 'react-router'
import { ModalDialog } from 'prove-common'

export function ReferenceDialog(props: ComponentProps<typeof ModalDialog>) {
  const location = useLocation()
  const context = useContext(UNSAFE_DataRouterContext)
  // Capture during the initial render, before the child's showModal effect.
  const [origin] = useState(() => ({
    trigger: document.activeElement,
    locationKey: location.key,
    href: window.location.href
  }))
  const mounted = useRef(false)

  useEffect(() => {
    mounted.current = true
    return () => {
      mounted.current = false
      // Wait for DOM removal; also avoid restoring during StrictMode replay.
      queueMicrotask(() => {
        const navigated = context
          ? context.router.state.location.key !== origin.locationKey
          : window.location.href !== origin.href
        const active = document.activeElement
        if (
          !mounted.current &&
          !navigated &&
          origin.trigger instanceof HTMLElement &&
          origin.trigger.isConnected &&
          origin.trigger !== document.body &&
          (!active || active === document.body || !active.isConnected)
        )
          origin.trigger.focus({ preventScroll: true })
      })
    }
  }, [context, origin])

  return <ModalDialog {...props} />
}
